// extracted by mini-css-extract-plugin
export default {"wrapper":"office_wrapper__fC7uA","inside":"office_inside__AhEP3","title":"office_title__U7PNs","item":"office_item__L6kTs"};